export default [
    {
        path: '/sucursales/listar',
        name: 'sucursales-listar',
        component: () => import('@/modules/facturacion/sucursales/views/ListadoViews.vue'),
        meta: {
            slug: 'area-ver', // para los permisos
        },
    },
];